import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Contact from "../components/contact";
import Hero from "../commercial/components/hero";
import TriCards from "../commercial/components/triCards";
import PageShell from "../components/pageShell";
import ZigZag from "../commercial/components/zigzag";
import BeforeAfter from "../commercial/components/beforeAfter";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const TanksPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Success Story - Tank Terminal - Flyby Shine</title>
                        <meta name="description" content="With Flyby Shine’s drones, tank cleaning dropped from four men over four days to a two-person, one day job." />
                        <meta name="keywords" content="Drone Cleaning, Drone Soft Wash, Pressure Wash, Drone-Assisted Pressure, Soft Washing Services, Drone cleaning technology, controlled pressure application, tailored to different surfaces, minimizing the risk of damage, valuable property, flexibility to adapt to various surfaces, architectural styles, high-rise office buildings, complex industrial sites, delicate historical structures, optimal results, faster and more efficient, disrupting your daily operations" />
                        <meta property="og:image" content="/assets/industrialAfter.png" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Success Story'}
                    title={'Tank Terminal - Sunshine, Louisiana'}
                    description={`Let's explore how Flyby Shine's drone cleaning services transformed tank cleaning at Tank Terminal in Sunshine, Louisiana.`}
                    banner={
                        {
                            image: '/assets/industrialAfter.png',
                            alt: 'A drone cleaning a tank',

                        }
                    }

                />

                <div className="success-story-article">
                    <div className="article-container">
                        <h2>
                            Success Story Breakdown
                        </h2>

                        <div className="case-study-grid">
                            {/* Problem */}
                            <div className="case-study-card" data-aos="fade-up">
                                <div className="card-header">
                                    <i className="material-icons">error_outline</i>
                                    <h3>Problem</h3>
                                </div>
                                <p>
                                    The client’s traditional method of cleaning above-ground storage tanks required
                                    4 men on 4 scissor lifts for 4 days per tank.  <strong> The process was
                                        slow, hazardous, and frequently disrupted terminal operations by damaging the surrounding dirt work.</strong>
                                </p>
                            </div>

                            {/* Solution */}
                            <div className="case-study-card" data-aos="fade-up" data-aos-delay="100">
                                <div className="card-header">
                                    <i className="material-icons">lightbulb_outline</i>
                                    <h3>Solution</h3>
                                </div>
                                <p>
                                    Flyby Shine provided a<strong> drone-powered alternative that eliminated lifts entirely</strong>.
                                    Using a two-man crew, we safely completed each tank in a
                                    single day without disturbing the surrounding area or increasing risk exposure.
                                </p>
                            </div>

                            {/* Outcome */}
                            <div className="case-study-card" data-aos="fade-up" data-aos-delay="200">
                                <div className="card-header">
                                    <i className="material-icons">check_circle_outline</i>
                                    <h3>Results</h3>
                                </div>
                                <p>
                                    The client gained a faster, safer, and more efficient tank-cleaning solution.
                                    With<strong> fewer boots on the ground, no equipment congestion, and zero impact on dirt work,</strong>
                                    Flyby Shine proved to be the smarter, safer upgrade for terminal maintenance.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


                <BeforeAfter
                    title={"Before And After"}
                    description={"Our drones can reach high areas safely and efficiently, providing a thorough cleaning solution for industrial buildings."}
                    subTitle={"Industrial Cleaning"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Efficient & Fast Cleaning</li>
                                <li><i className="material-icons">check_circle_outline</i>Safe: No more ladders or platforms</li>
                                <li><i className="material-icons">check_circle_outline</i>Reach Inaccessible Areas</li>
                            </ul>
                        </div>
                    }
                    images={[{
                        firstImage: {
                            imageUrl: '/assets/industrialAfter.png',
                        },
                        secondImage: {
                            imageUrl: '/assets/industrialBefore.png',
                        }

                    }
                    ]}

                />

                <Contact />
            </PageShell>
            <style>
                {
                    `
                    .zigzag {
                    margin-top: 150px
                    }

                    .hero-text > span {
                    font-size: 25px;
                    color: var(--main-color);
                    font-weight: 700;
                    }
               
                    
                    
                    `
                }
            </style>

        </>
    )
}

export default TanksPage
